import {
  BlueBox,
  InnerWrapper,
  List,
  ListWrapper,
  Section,
  SubTitle,
  Title
} from './EvEligibility.styles';

export default function HowVehiclesQualify() {
  return (
    <Section>
      <Title>How Do Vehicles Qualify for the EV Tax Credit?</Title>
      <p className="mt-xl text-text-default t-body-md sm:t-body-lg">
        A used EV must meet a number of qualifying criteria to be eligible for
        the used EV tax credit.{' '}
      </p>
      <BlueBox>
        <InnerWrapper>
          <ListWrapper>
            <SubTitle>
              To qualify for the federal used EV tax credit, the vehicle must:
            </SubTitle>
            <List>
              <li>
                Have a sale price of $25,000 or less, including non-government
                fees (e.g., shipping and delivery fees); and
              </li>
              <li>
                Be manufactured at least two years prior to the year of purchase
                (so for 2024, only cars made in 2022 and earlier qualify).
              </li>
            </List>
          </ListWrapper>
          <ListWrapper>
            <SubTitle>Additionally, the vehicle must:</SubTitle>
            <List>
              <li>
                Be a Fuel Cell Vehicle or plug-in EV with a battery capacity of
                at least 7 kilowatt hours;
              </li>
              <li>Be bought for use primarily within the U.S.;</li>
              <li>
                Have a gross vehicle weight rating of less than 14,000 pounds;
              </li>
              <li>
                Have not been purchased by another individual since August 16,
                2022.
              </li>
            </List>
          </ListWrapper>
        </InnerWrapper>
      </BlueBox>
    </Section>
  );
}
